import React from "react";
import dayjs from "dayjs";
import {
	Card,
	CardContent,
	Divider,
	Grid,
	Container,
	Typography,
	makeStyles,
	Button,
} from "@material-ui/core";
import { useAuth } from "contexts/auth-context";
import { Link } from "react-router-dom";

import data from "data/alumni.json";

const useStyles = makeStyles((theme) => ({
	container: { padding: theme.spacing(4, 3, 4, 3) },

	image: {
		height: 200,
		// height: "100%",
		// width: 200,
		borderRadius: theme.shape.borderRadius,
		boxShadow: theme.shadows[1],
	},
	divider: {
		margin: theme.spacing(2),
	},
}));
const Person = (props) => {
	const { image, dates, position, organization, current, links, name } = props;
	const classes = useStyles();
	console.log(process.env.PUBLIC_URL);
	console.log(`${process.env.PUBLIC_URL}${image}`);
	return (
		<div>
			<Typography variant="h5">{name}</Typography>
			{image && (
				<img
					className={classes.image}
					src={`${process.env.PUBLIC_URL}/${image}`}
				/>
			)}
			<Typography variant="h6">With City@UMD {name} was:</Typography>

			<Typography>{position}</Typography>
			<Typography>{organization}</Typography>
			<Typography>
				From: {dayjs(dates?.start, "MM-DD-YYYY").format("MMM YYYY")} to{" "}
				{dayjs(dates?.end, "MM-DD-YYYY").format("MMM YYYY")}
			</Typography>
			<Typography variant="h6">{name} is currently:</Typography>

			<Typography>{current?.position}</Typography>
			<Typography>{current?.organization}</Typography>
			{current?.asOf && (
				<small>As of: {dayjs(current?.asOf).format("MM/DD/YYYY")}</small>
			)}

			<ul>
				{links.map(({ title, href }, i) => (
					<li key={i}>
						<a href={href}>{title}</a>
					</li>
				))}
			</ul>
		</div>
	);
};
function Alumni() {
	const classes = useStyles();
	const { user } = useAuth();

	return (
		<Container className={classes.container}>
			<Grid container direction="row" spacing={2}>
				<Grid item sm={12} md={6}>
					<Typography variant="h4" component="h1" gutterBottom>
						Alumni
					</Typography>
					<Typography gutterBottom>{data?.intro}</Typography>
					<Button
						fullWidth
						style={{ marginTop: 8 }}
						variant="outlined"
						color="primary"
						component={Link}
						to="/about"
					>
						Learn more about City@UMD and see all the current City@UMD working
						members.
					</Button>
				</Grid>
			</Grid>
			<Divider className={classes.divider} />
			<Typography variant="h4" component="h1" gutterBottom>
				Alumni
			</Typography>
			<Grid container direction="row" spacing={2}>
				{data?.members
					.sort((a, b) => new Date(b?.dates?.end) - new Date(a?.dates?.end))
					.map((member, i) => (
						<Grid key={`person:${i}`} sm={12} md={4} xl={3}>
							<Person {...member} />
						</Grid>
					))}
			</Grid>
		</Container>
	);
}
export default Alumni;
